import Lottie from 'lottie-react'
import { useTranslation } from 'react-i18next'
import loadingAnimation from '@/assets/spinner/vs-account-loading.json'
import styles from './Loading.module.css'

const Loading = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.loadingWrap}>
      <div className={styles.animation}>
        <Lottie animationData={loadingAnimation} loop autoPlay aria-hidden />
      </div>
      <p className={styles.loadingText}>{t('common.loading')}</p>
    </div>
  )
}

export default Loading
